import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgIFrameComponent } from "./ng-iframe.component";

@NgModule({
    imports: [CommonModule],
    declarations: [NgIFrameComponent],
    exports: [NgIFrameComponent]
})
export class NgIFrameModule {
}
